import React from "react";

const LittleButton = ({ title, onChangeValue, disabled, color }) => {
    return (
        <button
            className="little-button"
            disabled={disabled}
            style={{ backgroundColor: color }}
            type="button"
            onClick={onChangeValue}
        >
            {title}
        </button>
    );
};

export default LittleButton;
